export const ALERT_STYLE_ID = 'solidjs-modus-ui-alert-styles';

export const ALERT_CONTAINER_CLASS = 'solidjs-modus-ui-alert';
export const ALERT_COMPACT_CLASS = 'solidjs-modus-ui-alert--compact';

export type AlertVariant = 'error' | 'info' | 'success' | 'warning';

/**
 * Prefix used to identify Trimble Connect font icon strings.
 * Strings starting with this prefix are rendered as
 * `<modus-wc-icon custom-class="icon-font {name} i24">` inside the `content`
 * slot. All other strings are treated as Modus icon names and forwarded to
 * `modus-wc-alert`'s native `icon` attribute.
 */
export const TC_ICON_PREFIX = 'tc-icon-';

export const ALERT_CSS = `
  /* Hide the default leading modus-wc-icon so the content slot's custom icon
     takes its place. Targets light DOM — validated against v1.0.3. */
  .${ALERT_CONTAINER_CLASS} .has-custom-icon > modus-wc-icon {
    display: none;
  }
  /* modus-wc-styles.css uses grid-template-columns:auto minmax(auto,1fr) at
     640px+. The three grid items are: icon (col1 auto) | content (col2 minmax)
     | button (col3 auto-generated). Changing the content column to
     minmax(0,1fr) lets it shrink below its min-content so the text word-wraps
     instead of pushing the button outside the alert box. The icon and button
     columns stay "auto" so they keep their natural widths. */
  @media (min-width: 640px) {
    .${ALERT_CONTAINER_CLASS} .modus-wc-alert {
      grid-template-columns: auto minmax(0, 1fr);
    }
  }
  /* Custom-icon path: the leading icon is hidden (display:none) so only two
     items remain — content and button. Correct the column order so content
     gets the stretchy column and the button stays at its natural width. */
  .${ALERT_CONTAINER_CLASS} .has-custom-icon {
    justify-items: start;
    text-align: start;
  }
  @media (min-width: 640px) {
    .${ALERT_CONTAINER_CLASS} .has-custom-icon {
      grid-template-columns: minmax(0, 1fr) auto;
    }
  }
  /* !important needed to override modus-wc-alert's own padding/min-height,
     which wins on specificity when the host page loads Modus styles after ours. */
  .${ALERT_COMPACT_CLASS} {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    min-height: 0 !important;
  }
`;
